module.exports = __webpack_public_path__ + "static/media/ic_edit.63a2faa8.svg";